import React from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { ProblemSection } from './components/ProblemSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingSection } from './components/PricingSection';
import { SistemaOperativoSection } from './components/SistemaOperativoSection';
import { ComparisonTableExtended } from './components/ComparisonTableExtended';
import { TestimonialsPreGuarantee } from './components/TestimonialsPreGuarantee';
import { ProductCarousel } from './components/ProductCarousel';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { ComparisonTable } from './components/ComparisonTable';
import { FinalCTA } from './components/FinalCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen bg-[#0B0B12] font-sans selection:bg-brand-gold selection:text-black text-slate-100" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <Testimonials data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <div className="bg-[#0B0B12] py-12 border-y border-white/5" data-id="element-5">
        <div className="max-w-xl mx-auto px-5 text-center" data-id="element-6">
          <p className="text-white font-black text-[18px] leading-tight uppercase tracking-wider" data-id="element-7">
            ESTO NO ES SOLO MATERIAL PARA LEER.
            <br data-id="element-8" />
            <span className="gold-text-gradient" data-id="element-9">
              ES UN SISTEMA PROFESIONAL PARA PELUQUERÍA REAL
            </span>
          </p>
        </div>
      </div>
      <TomosSection data-id="element-10" />
      <BonusSection data-id="element-11" />
      <ProductCarousel data-id="element-12" />
      <CountdownTimer data-id="element-13" />
      <PricingSection data-id="element-14" />
      <SistemaOperativoSection data-id="element-15" />
      <ComparisonTableExtended data-id="element-16" />
      <TestimonialsPreGuarantee data-id="element-17" />
      <Guarantee data-id="element-18" />
      <FAQ data-id="element-19" />
      <ComparisonTable data-id="element-20" />
      <FinalCTA data-id="element-21" />

      <div className="max-w-xl mx-auto px-5 py-6 text-center" data-id="element-22">
        <p className="text-white text-lg font-black uppercase tracking-tight" data-id="element-23">
          PORQUE UNA COSA ES SABER HACER PELUQUERÍA.
        </p>
        <p className="text-2xl font-black mb-4 gold-text-gradient" data-id="element-24">
          👉 Y OTRA MUY DISTINTA ES TRABAJAR COMO UNA PROFESIONAL ESTRUCTURADA.
        </p>
        <p className="text-white text-3xl font-black" data-id="element-25">
          💥 Y eso puede cambiar muchísimo tu día a día.
        </p>
      </div>

      <PurchasePopup data-id="element-26" />
    </div>;
}